import React, { useEffect, useRef, useState } from 'react'
import './Auditentry.css'
import cash from "../../imgs/cash.png";
import back from "../../imgs/backexam.png";
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { UilEditAlt, UilTrash, UilSetting } from '@iconscout/react-unicons'
import { useLocation, useNavigate } from "react-router-dom";
import Globalcontext from '../../Context/Globalcontext';
import date from "../../imgs/bdate.png";
import { useTranslation } from "react-i18next";

const Auditentry = (props) => {
  const { t } = useTranslation();

  const inputRefs = useRef([]);
  const [newedit, setNewedit] = useState("new");
  const [input, setInput] = useState({
    date: new Date().toISOString().substr(0, 10),
    kno: "", name: "", headname: "", khtype: "",
    type: "",
    kno2: "", name2: "", headname2: "", khtype2: "", type2: "",
    kno3: "", name3: "",
    amt: "", remark: "", tamt: "",
    etype: t("Auditentry.entryTypes.cash") // ✅ default via key
  });

  const [DataSource, setDataSource] = useState([]);
  const [tableFilter, setTableFilter] = useState([]);
  const [dates, setDates] = useState({ date1: "", date2: new Date().toISOString().substr(0, 10) });
  const [khnames, setKhnames] = useState([]);
  const [value, setValue] = useState('');
  const notify = (msg) => toast(msg);
  const notifyerror = (msg) => toast.error(msg);
  const [stock, setStock] = useState();
  const [sredit, setSredit] = useState('');
  const refprint2 = useRef(null);
  const refprint2close = useRef(null);
  const [srdelete, setSrdelete] = useState('');
  const refdelete = useRef(null);
  const refdeleteclose = useRef(null);
  const [wait, setWait] = useState(false);
  const today = new Date().toISOString().split('T')[0];
  const [className, setClassName] = useState("");

  function handleEnterKey(event, currentIndex) {
    if (event.key === 'Enter' || event.key === "Tab") {
      event.preventDefault();
      let nextIndex = currentIndex + 1;
      if (inputRefs.current[nextIndex]) {
        inputRefs.current[nextIndex].focus();
      }
    }

    if (event.key === 'Backspace' && (
      (event.target.tagName === 'INPUT' && event.target.value === '') ||
      (event.target.tagName === 'SELECT' && (
        (event.target.name === 'type' && event.target.value === t("Auditentry.placeholders.selectType"))
      ))
    )) {
      event.preventDefault();
      let prevIndex = currentIndex - 1;
      while (prevIndex >= 0) {
        const prevElement = inputRefs.current[prevIndex];
        if (prevElement) {
          if (
            (prevElement.tagName === 'INPUT' || prevElement.tagName === 'SELECT') &&
            prevElement !== event.target
          ) {
            prevElement.focus();
            break;
          } else {
            prevIndex--;
          }
        } else {
          prevIndex--;
        }
      }
    }
  }

  const filteDataclass = (classname) => {
    const searchValue = classname;
  };

  const handleChangeactive = (event) => {
    var checked = event.target.checked;
  }

  const formatDate = (dateString) => {
    const d = new Date(dateString);
    return d.toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    }).replace(/ /g, '-');
  };

  const handleChange = async (event) => {
    const name = event.target.name;
    let valuecurrent = event.target.value;

    setInput(value => ({ ...value, [name]: valuecurrent }));

    if (name === 'date') {
      if (valuecurrent === "" || valuecurrent === "dd/mm/yyyy" || valuecurrent > today) {
        setInput(prevInput => ({
          ...prevInput,
          date: prevInput.date && prevInput.date <= today ? prevInput.date : today
        }));
        return;
      }
    }
  }

  // -------- lookup kno -> auditlist ----------
  useEffect(() => {
    if (input.kno === "") {
      setInput(prevInput => ({
        ...prevInput,
        kno: "",
        name: "",
        headname: "",
        khtype: "",
        type: "",
      }))
      setNewedit("new");
    } else {
      let custlisttemp = JSON.parse(localStorage.getItem("auditlist"));
      for (let i = 0; i < custlisttemp.length; i++) {
        setInput(prevInput => ({ ...prevInput, name: '' }));
        const user = custlisttemp[i];
        if (user.kno === input.kno) {
          setInput(prevInput => ({
            ...prevInput,
            name: user.name,
            headname: user.headname,
            khtype: user.type
          }));
          break;
        }
      }
    }
  }, [input.kno])

  useEffect(() => {
    if (input.kno2 === "") {
      setInput(prevInput => ({
        ...prevInput,
        kno2: "",
        name2: "",
        headname2: "",
        khtype2: "",
      }))
    } else {
      let custlisttemp = JSON.parse(localStorage.getItem("auditlist"));
      for (let i = 0; i < custlisttemp.length; i++) {
        setInput(prevInput => ({ ...prevInput, name2: '' }));
        const user = custlisttemp[i];
        if (user.kno === input.kno2) {
          setInput(prevInput => ({
            ...prevInput,
            name2: user.name,
            headname2: user.headname,
            khtype2: user.type
          }));
          break;
        }
      }
    }
  }, [input.kno2])

  useEffect(() => {
    if (input.type === "Debit") {
      setInput(prevInput => ({ ...prevInput, type2: "Credit" }))
    } else if (input.type === "Credit") {
      setInput(prevInput => ({ ...prevInput, type2: "Debit" }))
    }
  }, [input.type])

  useEffect(() => {
    if (input.kno3 === "") {
      setInput(prevInput => ({ ...prevInput, kno3: "", name3: "" }))
    } else {
      let custlisttemp = JSON.parse(localStorage.getItem("custlist"));
      for (let i = 0; i < custlisttemp.length; i++) {
        setInput(prevInput => ({ ...prevInput, name3: '' }));
        const user = custlisttemp[i];
        if (user.kno === input.kno3) {
          setInput(prevInput => ({ ...prevInput, name3: user.cname }));
          break;
        }
      }
    }
  }, [input.kno3])

  function handleEnterKeybutton(event, currentIndex) {
    if (event.key === 'Enter') {
      event.preventDefault();
      saveauditentry();
      let nextIndex = null;
      if (currentIndex === 0) {
        nextIndex = input.name !== "" ? currentIndex + 1 : currentIndex;
      } else {
        nextIndex = currentIndex + 1;
      }
      if (inputRefs.current[nextIndex]) inputRefs.current[nextIndex].focus();
    } else if (event.key === "Backspace") {
      if (event.target.tagName === "BUTTON") {
        if (inputRefs.current[4]) inputRefs.current[4].focus();
      }
    }
  }

  const saveauditentry = () => {
    setWait(true);
    var mainuser2 = jsEncode.encode("mamapr", 125);

    const selectTypeLabel = t("Auditentry.placeholders.selectType");
    if (
      input.date === "" ||
      input.kno === "" ||
      input.name === "" ||
      (input.type === selectTypeLabel || input.type === "") ||
      input.amt === "" ||
      input.remark === ""
    ) {
      notifyerror(t("Auditentry.toast.incompleteEntry"));
      setWait(false);
      return;
    }

    let rawData = {
      date: input.date,
      kno: input.kno,
      kno2: input.kno2,
      kno3: input.kno3,
      etype: input.etype,
      type: input.type,
      amt: input.amt,
      remark: input.remark,
      mainuser: localStorage.getItem("contact"),
      mainuser2: mainuser2,
      flag: newedit,
      sredit: sredit,
    }

    rawData = JSON.stringify(rawData)
    let formData = new FormData()
    formData.append('data', rawData)

    axios.post('https://excellentdairy.com/dairy/php/cust/saveauditentry3.php', formData, {
      'Content-Type': 'multipart/form-data',
    }).then(function sample(response) {
      if (newedit === "new") {
        if (String(response.data).trim() === "Saved.") {
          notify(t("Auditentry.toast.entrySaved"));
          setWait(false);
        }
      } else {
        if (String(response.data).trim() === "updated.") {
          notify(t("Auditentry.toast.entryUpdated"));
          setWait(false);
        }
      }

      setInput(prevInput => ({
        ...prevInput,
        kno: "",
        kno2: "",
        kno3: "",
        type: "",
        amt: "",
        remark: "",
      }))
      setSredit("");
      setNewedit("new");
      getauditentry(dates.date1, dates.date2);

      if (inputRefs.current[1]) inputRefs.current[1].focus();
    }).catch(err => {
      console.log(err);
      setWait(false);
    });
  }

  // --- period logic (unchanged) ---
  useEffect(() => {
    const currentDate1 = new Date(dates.date1);
    const dayOfMonth1 = currentDate1.getDate();
    const currentMonth1 = currentDate1.getMonth();
    const currentYear1 = currentDate1.getFullYear();
    let lastDayOfMonth1;

    if (localStorage.getItem("dur") === '10') {
      if (dayOfMonth1 >= 1 && dayOfMonth1 <= 10) lastDayOfMonth1 = 10;
      else if (dayOfMonth1 >= 11 && dayOfMonth1 <= 20) lastDayOfMonth1 = 20;
      else if (dayOfMonth1 >= 21 && dayOfMonth1 <= 30) lastDayOfMonth1 = new Date(currentYear1, currentMonth1 + 1, 0).getDate();
    } else if (localStorage.getItem("dur") === '15') {
      if (dayOfMonth1 >= 1 && dayOfMonth1 <= 15) lastDayOfMonth1 = 15;
      else if (dayOfMonth1 >= 16 && dayOfMonth1 <= 30) lastDayOfMonth1 = new Date(currentYear1, currentMonth1 + 1, 0).getDate();
    }

    if (lastDayOfMonth1 !== undefined) {
      const formattedDate2 = new Date(currentYear1, currentMonth1, lastDayOfMonth1).toLocaleDateString('en-CA');
      setDates(prevInput => ({ ...prevInput, date2: formattedDate2 }));
    }
  }, [dates.date1]);

  useEffect(() => {
    const currentDate1 = new Date(input.date);
    const dayOfMonth1 = currentDate1.getDate();
    const currentMonth1 = currentDate1.getMonth();
    const currentYear1 = currentDate1.getFullYear();

    let lastDayOfMonth1, firstday;

    if (localStorage.getItem("dur") === '10') {
      if (dayOfMonth1 >= 1 && dayOfMonth1 <= 10) { firstday = "1"; lastDayOfMonth1 = 10; }
      else if (dayOfMonth1 >= 11 && dayOfMonth1 <= 20) { firstday = "11"; lastDayOfMonth1 = 20; }
      else if (dayOfMonth1 >= 21 && dayOfMonth1 <= 30) { firstday = "21"; lastDayOfMonth1 = new Date(currentYear1, currentMonth1 + 1, 0).getDate(); }
    } else if (localStorage.getItem("dur") === '15') {
      if (dayOfMonth1 >= 1 && dayOfMonth1 <= 15) { firstday = "1"; lastDayOfMonth1 = 15; }
      else if (dayOfMonth1 >= 16 && dayOfMonth1 <= 30) { firstday = "16"; lastDayOfMonth1 = new Date(currentYear1, currentMonth1 + 1, 0).getDate(); }
    }

    if (lastDayOfMonth1 !== undefined) {
      const formattedDate1 = new Date(currentYear1, currentMonth1, firstday).toLocaleDateString('en-CA');
      const formattedDate2 = new Date(currentYear1, currentMonth1, lastDayOfMonth1).toLocaleDateString('en-CA');
      setDates(prevInput => ({ ...prevInput, date1: formattedDate1, date2: formattedDate2 }));
    }
  }, [input.date]);

  useEffect(() => {
    if (inputRefs.current[1]) inputRefs.current[1].focus();

    const currentDate = new Date();
    const dayOfMonth = currentDate.getDate();
    const currentMonth = currentDate.getMonth();
    const currentYear = currentDate.getFullYear();

    let firstDayOfMonth;
    let lastDayOfMonth;

    if (localStorage.getItem("dur") === '10') {
      if (dayOfMonth >= 1 && dayOfMonth <= 10) { firstDayOfMonth = 1; lastDayOfMonth = 10; }
      else if (dayOfMonth >= 11 && dayOfMonth <= 20) { firstDayOfMonth = 11; lastDayOfMonth = 20; }
      else if (dayOfMonth >= 21 && dayOfMonth <= 30) { firstDayOfMonth = 21; lastDayOfMonth = new Date(currentYear, currentMonth + 1, 0).getDate(); }
    } else if (localStorage.getItem("dur") === '15') {
      if (dayOfMonth >= 1 && dayOfMonth <= 15) { firstDayOfMonth = 1; lastDayOfMonth = 10; }
      else if (dayOfMonth >= 16 && dayOfMonth <= 30) { firstDayOfMonth = 16; lastDayOfMonth = new Date(currentYear, currentMonth + 1, 0).getDate(); }
    }

    if (firstDayOfMonth !== undefined && lastDayOfMonth !== undefined) {
      const formattedDate1 = new Date(currentYear, currentMonth, firstDayOfMonth).toLocaleDateString('en-CA');
      const formattedDate2 = new Date(currentYear, currentMonth, lastDayOfMonth).toLocaleDateString('en-CA');
      setDates(prevInput => ({ ...prevInput, date1: formattedDate1, date2: formattedDate2 }));
      getauditentry(formattedDate1, formattedDate2);
    }
  }, [])

  const setNewPeriod = async () => {
    getauditentry(dates.date1, dates.date2)
  }

  const handleChangedates = async (event) => {
    const name = event.target.name;
    let valuecurrent = event.target.value;
    setDates(value => ({ ...value, [name]: valuecurrent }));
  }

  async function getauditentry(date1, date2) {
    var mainuser2 = jsEncode.encode("mamapr", 125);
    axios.post('https://excellentdairy.com/dairy/php/cust/getauditentries.php', {
      date1: date1, date2: date2, date: input.date, time: input.time,
      mainuser: localStorage.getItem("contact"), mainuser2: mainuser2
    }).then(function sample(response) {
      if (response.data.length > 0) {
        setDataSource(response.data);
        setInput(value => ({ ...value, tamt: response.data[0].tamt }));
        setTimeout(() => { props.setProgress(100); }, 200);
        handleprintclose();
      } else {
        setDataSource([]);
        setInput(value => ({ ...value, tamt: "0" }));
        handleprintclose();
      }
    }).catch(err => {
      console.log(err);
      handleprintclose();
    });
  }

  const handleedit = (sr, date, kno, etype, type, amt, remark, kno2, kno3) => {
    setInput(prevInput => ({
      ...prevInput,
      sr: sr, date: date, kno: kno, etype: etype, type: type, amt: amt, remark: remark, kno2: kno2, kno3: kno3
    }))
    setNewedit("edit");
    setSredit(sr);
  }

  async function deleteuchal() {
    handleDeleteclose();
    var mainuser2 = jsEncode.encode("mamapr", 125);

    axios.post('https://excellentdairy.com/dairy/php/cust/deleteuchal.php', {
      sr: srdelete, mainuser: localStorage.getItem("contact"), mainuser2: mainuser2
    }).then(function sample(response) {
      if (response.data) {
        notify(response.data);
        setInput(prevInput => ({ ...prevInput, kno: "", name: "", type: "", amt: "" }))
        setSredit("");
        setNewedit("new");
        setSrdelete("");
        getauditentry(dates.date1, dates.date2);
        if (inputRefs.current[1]) inputRefs.current[1].focus();
      }
    }).catch(err => {
      console.log(err);
    });
  }

  var jsEncode = {
    encode: function (s, k) {
      var enc = "";
      var str = s.toString();
      for (var i = 0; i < str.length; i++) {
        var a = str.charCodeAt(i);
        var b = a ^ k;
        enc = enc + String.fromCharCode(b);
      }
      return enc;
    }
  };

  const handleprintclose = () => {
    refprint2close.current.click();
  }

  const handlePrint = () => {
    refprint2.current.click();
  }

  const handleDeleteclose = () => {
    setSrdelete("");
    refdeleteclose.current.click();
  }

  const handleDelete = (sr) => {
    setSrdelete(sr);
    refdelete.current.click();
  }

  const entryTypes = [
    t("Auditentry.entryTypes.cash"),
    t("Auditentry.entryTypes.transfer"),
  ];

  return (
    <>
      <button
        type="button"
        className="btn btn-primary"
        data-bs-toggle="modal"
        hidden="{true}"
        ref={refprint2}
        data-bs-target="#uchalperiod"
      ></button>

      {/* Period Modal */}
      <div className="modal fade" id="uchalperiod" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel"></h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" ref={refprint2close} aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <h5 className="modal-title" id="exampleModalLabel">{t("Auditentry.periodModal.title")}</h5>

              <div className="rowbill">
                <div className="mb-2">
                  <span className='subheadsank'>{t("Auditentry.labels.date")}</span>
                  <input
                    onKeyDown={e => handleEnterKey(e, 0)}
                    ref={ref => (inputRefs.current[0] = ref)}
                    type="date"
                    className="form-control"
                    autoComplete='off'
                    id="date1"
                    name="date1"
                    value={dates.date1}
                    onChange={handleChangedates}
                  />
                </div>

                <span className='subheadbill'>{t("Auditentry.labels.to")}</span>

                <div className="mb-2">
                  <span className='subheadsank'>{t("Auditentry.labels.date")}</span>
                  <input
                    disabled
                    onKeyDown={e => handleEnterKey(e, 1)}
                    ref={ref => (inputRefs.current[1] = ref)}
                    type="date"
                    className="form-control"
                    autoComplete='off'
                    id="date2"
                    name="date2"
                    value={dates.date2}
                    onChange={handleChangedates}
                  />
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={handleprintclose}>
                {t("Auditentry.buttons.close")}
              </button>
              <button type="button" className="btn btn-danger" onClick={setNewPeriod}>
                {t("Auditentry.buttons.ok")}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Delete Modal */}
      <button
        type="button"
        className="btn btn-primary"
        data-bs-toggle="modal"
        hidden="{true}"
        ref={refdelete}
        data-bs-target="#deleteuchal"
      ></button>

      <div className="modal fade" id="deleteuchal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel"></h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" ref={refdeleteclose} aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <h5 className="modal-title" id="exampleModalLabel">
                {t("Auditentry.deleteModal.title")}
              </h5>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={handleDeleteclose}>
                {t("Auditentry.buttons.close")}
              </button>
              <button type="button" className="btn btn-danger" onClick={deleteuchal}>
                {t("Auditentry.buttons.yes")}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Main */}
      <div className="khadyamain">
        <div className="firstrowkhadya">
          <img onClick={props.visibility} className='back' src={back} alt="" />
          <div className="colmainkhadya">
            <div className="firstrow2">
              <div className="row1kh100">
                <div className="divhori">
                  <div className="mb-2">
                    <span className='subheadsank'>{t("Auditentry.labels.date")}</span>
                    <input
                      onKeyDown={e => handleEnterKey(e, 0)}
                      ref={ref => (inputRefs.current[0] = ref)}
                      type="date"
                      className={newedit === "new" ? "form-control inputfont" : "form-control inputfont editmode"}
                      autoComplete='off'
                      id="date"
                      name="date"
                      value={input.date}
                      onChange={handleChange}
                    />
                  </div>

                  <div className='classvauditentry'>
                    <label>
                      <div className="classbox">
                        {entryTypes.map((etype) => (
                          <label key={etype}>
                            <div className='classbox'>
                              <input
                                type="radio"
                                name="etype"
                                value={etype}
                                checked={input.etype === etype}
                                onChange={(e) => {
                                  setInput(value => ({ ...value, etype: e.target.value }))
                                  if (inputRefs.current[1]) inputRefs.current[1].focus();
                                }}
                              />
                              <span className='classspan'>{etype}</span>
                              <div className='vlineclass'></div>
                            </div>
                          </label>
                        ))}
                      </div>
                    </label>
                  </div>
                </div>

                <div onClick={handlePrint} className="rightkhsaletopauditentry">
                  <img className='khadyaicon' src={date} alt="" />
                  <span className='khsaleblack'>
                    {t("Auditentry.labels.period")} :
                    <span className='khsaleblue'>
                      {formatDate(dates.date1) + " " + t("Auditentry.labels.to") + " " + formatDate(dates.date2)}
                    </span>
                  </span>
                </div>

              </div>
            </div>
          </div>
        </div>

        <div className='linekh' />

        {/* Entry row */}
        <div className="row1uchal">
          <div className="mb-2">
            <span className='subheadsank'>{t("Auditentry.labels.type")}</span>
            <select
              onKeyDown={e => handleEnterKey(e, 1)}
              ref={ref => (inputRefs.current[1] = ref)}
              value={input.type}
              name='type'
              id='typeaudit'
              onChange={handleChange}
              className={newedit === "new" ? "form-control inputfontkhlarge" : "form-control inputfontkhlarge editmode"}
            >
              <option defaultValue="Select Grade">{t("Auditentry.placeholders.selectType")}</option>
              <option value="Debit">{t("Auditentry.options.debit")}</option>
              <option value="Credit">{t("Auditentry.options.credit")}</option>
            </select>
          </div>

          <div className="mb-2">
            <span className='subheadsank'>{t("Auditentry.labels.accountNo")}</span>
            <input
              onKeyDown={e => handleEnterKey(e, 2)}
              ref={ref => (inputRefs.current[2] = ref)}
              type="number"
              className={newedit === "new" ? "form-control inputfontkh" : "form-control inputfontkh editmode"}
              autoComplete='off'
              id="kno"
              name="kno"
              value={input.kno}
              onChange={handleChange}
            />
          </div>

          <div className="mb-2">
            <span className='subheadsank'>
              {t("Auditentry.labels.accountName")} <span className='prev'>{" (" + input.headname + " : " + input.khtype + ")"}</span>
            </span>
            <input
              type="text"
              disabled
              className={newedit === "new" ? "form-control inputfontkhlarge" : "form-control inputfontkhlarge editmode"}
              autoComplete='off'
              id="name"
              name="name"
              value={input.name}
              onChange={handleChange}
            />
          </div>

          {/* Transfer Part */}
          {input.etype === t("Auditentry.entryTypes.transfer") ? (
            <div className="divhori">
              <div className='vlineaudit'></div>

              <div className="mb-2">
                <span className='subheadsank'>{t("Auditentry.labels.type")}</span>
                <select
                  disabled
                  onKeyDown={e => handleEnterKey(e, 3)}
                  ref={ref => (inputRefs.current[3] = ref)}
                  value={input.type2}
                  name='type2'
                  id='typeaudit2'
                  onChange={handleChange}
                  className={newedit === "new" ? "form-control inputfontkhlarge" : "form-control inputfontkhlarge editmode"}
                >
                  <option defaultValue="Select Grade">{t("Auditentry.placeholders.selectType")}</option>
                  <option value="Debit">{t("Auditentry.options.debit")}</option>
                  <option value="Credit">{t("Auditentry.options.credit")}</option>
                </select>
              </div>

              <div className="mb-2">
                <span className='subheadsank'>{t("Auditentry.labels.accountNo")}</span>
                <input
                  onKeyDown={e => handleEnterKey(e, 3)}
                  ref={ref => (inputRefs.current[3] = ref)}
                  type="number"
                  className={newedit === "new" ? "form-control inputfontkh" : "form-control inputfontkh editmode"}
                  autoComplete='off'
                  id="kno2"
                  name="kno2"
                  value={input.kno2}
                  onChange={handleChange}
                />
              </div>

              <div className="mb-2">
                <span className='subheadsank'>
                  {t("Auditentry.labels.accountName")} <span className='prev'>{" (" + input.headname2 + " : " + input.khtype2 + ")"}</span>
                </span>
                <input
                  type="text"
                  disabled
                  className={newedit === "new" ? "form-control inputfontkhlarge" : "form-control inputfontkhlarge editmode"}
                  autoComplete='off'
                  id="name2"
                  name="name2"
                  value={input.name2}
                  onChange={handleChange}
                />
              </div>
            </div>
          ) : null}
        </div>

        <div className='linekh' />

        <div className="row1uchal">
          <div className="hiddenclass"></div>

          <div className="mb-2">
            <span className='subheadsank'>{t("Auditentry.labels.subAccount")}</span>
            <input
              onKeyDown={e => handleEnterKey(e, input.etype === t("Auditentry.entryTypes.transfer") ? 4 : 3)}
              ref={ref => (inputRefs.current[input.etype === t("Auditentry.entryTypes.transfer") ? 4 : 3] = ref)}
              type="number"
              className={newedit === "new" ? "form-control inputfontkh" : "form-control inputfontkh editmode"}
              autoComplete='off'
              id="kno3"
              name="kno3"
              value={input.kno3}
              onChange={handleChange}
            />
          </div>

          <div className="mb-2">
            <span className='subheadsank'>{t("Auditentry.labels.subAccountName")}</span>
            <input
              type="text"
              disabled
              className={newedit === "new" ? "form-control inputfontkhlarge" : "form-control inputfontkhlarge editmode"}
              autoComplete='off'
              id="name3"
              name="name3"
              value={input.name3}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="row1uchal">
          <div className="hiddenclass"></div>

          <div className="mb-2 au">
            <span className='subheadsank'>{t("Auditentry.labels.amount")}</span>
            <input
              onKeyDown={e => handleEnterKey(e, input.etype === t("Auditentry.entryTypes.transfer") ? 5 : 4)}
              ref={ref => (inputRefs.current[input.etype === t("Auditentry.entryTypes.transfer") ? 5 : 4] = ref)}
              type="number"
              className={newedit === "new" ? "form-control inputfontkh" : "form-control inputfontkh editmode"}
              autoComplete='off'
              id="amtaudit2"
              name="amt"
              value={input.amt}
              onChange={handleChange}
            />
          </div>

          <div className="mb-2">
            <span className='subheadsank'>{t("Auditentry.labels.details")}</span>
            <input
              type="text"
              onKeyDown={e => handleEnterKey(e, input.etype === t("Auditentry.entryTypes.transfer") ? 6 : 5)}
              ref={ref => (inputRefs.current[input.etype === t("Auditentry.entryTypes.transfer") ? 6 : 5] = ref)}
              className={newedit === "new" ? "form-control inputfontkhlarge" : "form-control inputfontkhlarge editmode"}
              autoComplete='off'
              id="remarkaudit"
              name="remark"
              value={input.remark}
              onChange={handleChange}
            />
          </div>

          <div className="mb-2 saveaudit">
            {wait ? (
              <button type="submit" className="btn btn-primary mx-1 sanksmall saveauditbutton">
                {t("Auditentry.common.loading")}
              </button>
            ) : (
              <button
                onClick={saveauditentry}
                onKeyDown={e => handleEnterKeybutton(e, 0)}
                ref={ref => (inputRefs.current[input.etype === t("Auditentry.entryTypes.transfer") ? 7 : 6] = ref)}
                type="submit"
                className="btn btn-primary mx-1 sanksmall saveauditbutton"
              >
                {newedit === "new" ? t("Auditentry.buttons.save") : t("Auditentry.buttons.update")}
              </button>
            )}
          </div>
        </div>

        {/* Total */}
        <div hidden className="row1uchal2">
          <div className="mb-2">
            <div className="row1uchal2">
              <div className="rightkhsale">
                <img className='khadyaicon' src={cash} alt="" />
                <span className='uchalblack'>
                  {t("Auditentry.labels.amount")} :
                  <span className='khsalered'>₹{parseFloat(input.tamt).toFixed(2)}</span>
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="firstrow2">
          <div className="table-containerauditentry">
            <table id="myTable" className="table table-bordered">
              <thead>
                <tr>
                  <th className='thsmall' scope="col">{t("Auditentry.table.srNo")}</th>
                  <th className='thsmall' scope="col">{t("Auditentry.table.date")}</th>
                  <th className='thsmall' scope="col">{t("Auditentry.table.accountNo")}</th>
                  <th className='thlarge' scope="col">{t("Auditentry.table.accountName")}</th>
                  <th className='thsmall' scope="col">{t("Auditentry.table.entryType")}</th>
                  <th className='thsmall' scope="col">{t("Auditentry.table.type")}</th>
                  <th className='thsmall' scope="col">{t("Auditentry.table.amount")}</th>
                  <th className='thsmall' scope="col">{t("Auditentry.table.action")}</th>
                </tr>
              </thead>

              <tbody>
                {value.length > 0 ? (
                  tableFilter.map((user, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{user.date}</td>
                      <td>{user.kno}</td>
                      <td>{user.name}</td>
                      <td>{user.etype}</td>
                      <td>{user.type}</td>
                      <td>{user.amt}</td>
                    </tr>
                  ))
                ) : (
                  DataSource.map((user, index) => (
                    <tr key={index}>
                      <td className='thsmallaudit'>{index + 1}</td>
                      <td className='thsmallaudit'>{user.date}</td>
                      <td className='thsmallaudit'>{user.kno}</td>
                      <td className='thsmallaudit'>{user.name}</td>
                      <td className='thsmallaudit'>{user.etype}</td>
                      <td className='thsmallaudit'>{user.type}</td>
                      <td className='thsmallaudit'>{user.amt}</td>
                      <td>
                        <UilEditAlt
                          onClick={() => { handleedit(user.sr, user.date, user.kno, user.etype, user.type, user.amt, user.remark, user.kno2, user.kno3) }}
                          className="icsank"
                        />
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        <ToastContainer />
      </div>
    </>
  )
}

export default Auditentry
